import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Box } from '@material-ui/core';
import { useTicketInformation } from './styles';
import { textInCapitalCase } from '../../../../helpers/TextHelper';

const TicketInformation = ({ ...props }) => {
  const { name, tickets } = props;
  const classes = useTicketInformation();
  return (
    <Box display="flex" flexDirection="column">
      <Typography data-cy="ticketName" className={classes.title}>
        {textInCapitalCase(name)}
      </Typography>
      {tickets.map((ticket, index) => (
        <Typography className={classes.ticket} key={index}>
          <strong>Solicitud {ticket.id}:</strong> {ticket.motiveName}
        </Typography>
      ))}
    </Box>
  );
};

TicketInformation.propTypes = {
  name: PropTypes.string,
  tickets: PropTypes.array,
};

export default TicketInformation;
